
import Navbar from '@/components/navbar/Navbar.vue';
export default {
  components: {
    Navbar
  }
};
